export const timeDisplayReverse = (display) => {
  const [hour, min, sec] = display.split(':');
  return parseInt(hour) * 60 * 60 + parseInt(min) * 60 + parseFloat(sec);
};

export const validTimeDisplay = (display) => {
  return display.match(/^\d+:\d+:\d+.?\d*$/);
};

export const validEventTimestampDisplay = (display) => {
  return display.match(/^\d{4}-\d{2}-\d{2} \d+:\d+:\d+.?\d*$/);
};
